var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9,0.9c-9.8,0-17.8,8-17.8,17.8c0,2.5,0.5,5,1.6,7.3c4.2,8.2,9.4,15.9,15.5,22.9   c0.4,0.4,1,0.5,1.4,0.1c0,0,0.1-0.1,0.1-0.1c6.1-7,11.3-14.7,15.5-22.9c1-2.3,1.6-4.7,1.6-7.3C55.6,8.8,47.7,0.9,37.9,0.9z    M37.9,27.9c-5.1,0-9.2-4.1-9.2-9.2c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2v0C47.1,23.7,43,27.9,37.9,27.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.470aaa4696bdc176c048db303af812b3.svg";
export { ForwardRef as ReactComponent };